export default __webpack_public_path__ + "static/media/race_of_the_reapers_2.04e86472.png";